import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import WorkflowProcessStore from '../stores/WorkflowProcessStore';

import ExecutorRow from './WorkflowProcessHistory/ExecutorRow';

class WorkflowProcessHistory extends Component {
  constructor(){
    super();

    this.state = {
      workflow_process: {},
      workflow_process_histories: [],
      workflow_states: [],
      workflow_state_actions: [],
      loading: true,
      showingTabId: null,
      clicked: false
    }

    this.renderHistoryRow = this.renderHistoryRow.bind(this);
    this.renderHistoryTab = this.renderHistoryTab.bind(this);
    this.renderCurrentRow = this.renderCurrentRow.bind(this);
    this.renderCurrentTab = this.renderCurrentTab.bind(this);
    this.showHistoryTab   = this.showHistoryTab.bind(this);
    this.renderTrackingRow   = this.renderTrackingRow.bind(this);
    this.renderTrackingTab   = this.renderTrackingTab.bind(this);
    this.renderTrackingData   = this.renderTrackingData.bind(this);
    this.showTrackingTab   = this.showTrackingTab.bind(this);
    this.preventMultiClicks   = this.preventMultiClicks.bind(this);
    this.handleResendClicked   = this.handleResendClicked.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const nextId = nextProps.id;
    const currentId = this.props.id;
    this.setState({loading: true});

    if (nextId && nextId !== currentId) {
      WorkflowProcessStore.request({id: nextProps.id}).then((resp)=>{
        let workflow_process = _.get(resp.data, 'data', {});
        let included = _.get(resp.data, 'included', {});
        let workflow_process_histories = included.workflow_process_histories || [];
        let workflow_states = included.workflow_states || [];
        let workflow_state_actions = included.workflow_state_actions || [];
        let campus_tracking_data = _.get(workflow_process, "attributes.campus_tracking_data");

        this.setState({
          workflow_process: workflow_process,
          workflow_process_histories: workflow_process_histories,
          workflow_states: workflow_states,
          workflow_state_actions: workflow_state_actions,
          showingTabId: _.isEmpty(campus_tracking_data) ? workflow_process.id : "tracking",
        })
      }).then(()=>{
        this.setState({loading: false});
      })
    }
  }

  showHistoryTab(id){
    this.setState({showingTabId: id});
  }

  preventMultiClicks(){
    this.setState({clicked: true});
  }

  handleResendClicked(workflow_process_id){
    this.preventMultiClicks();

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      action: 'retry_campus_sending'
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  renderHistoryRow(workflow_process_history){
    const workflow_state = _.find(this.state.workflow_states, { id: workflow_process_history.attributes.workflow_state.id } )
    const workflow_state_action = _.find(this.state.workflow_state_actions, { id: workflow_process_history.attributes.workflow_state_action.id } )
    const isShowing = this.state.showingTabId === workflow_process_history.id;

    return(
      <a  key={workflow_process_history.id} 
          className={`nav-link text-black ${isShowing && "active"}`}
          data-toggle="pill" 
          href="#"
          role="tab" 
          aria-controls={`v-pills-${workflow_process_history.id}`} 
          aria-selected="true"
          onClick={() => this.showHistoryTab(workflow_process_history.id)}>
            <i className="fa fa-check-square-o"></i>{' '}
            <span>
              {workflow_state.attributes.state_name}{" - "}
              <b>{workflow_state_action.attributes.action_name}</b>
            </span>
      </a>
    )
  }

  renderCurrentRow(workflow_process){
    const current_state_name = _.get(workflow_process, "attributes.current_workflow_state.attributes.state_name");
    const isShowing = this.state.showingTabId === workflow_process.id;

    return(
      <a  key={workflow_process.id} 
          className={`nav-link text-black ${isShowing && "active"}`}
          data-toggle="pill" 
          href="#"
          role="tab" 
          aria-controls={`v-pills-${workflow_process.id}`} 
          aria-selected="true"
          onClick={() => this.showHistoryTab(workflow_process.id)}>
            <i className="fa fa-envelope-o"></i>{' '}
            <span>{ current_state_name }</span>
      </a>
    )
  }

  renderHistoryTab(workflow_process_history){
    const workflow_state_action = _.find(this.state.workflow_state_actions, { id: workflow_process_history.attributes.workflow_state_action.id } );
    const action_name = workflow_state_action.attributes.action_name;

    const isShowing = this.state.showingTabId === workflow_process_history.id;
    const executor = _.get(workflow_process_history, "attributes.executor");
    const cc_users = _.get(workflow_process_history, "attributes.cc_positions_users");

    const created_at = _.get(workflow_process_history, "attributes.created_at");
    const updated_at = _.get(workflow_process_history, "attributes.updated_at");

    return(
      <div  key={workflow_process_history.id}
            className={`tab-pane fade ${isShowing && "show active"}`}
            id={`v-pills-${workflow_process_history.id}`}
            role="tabpanel" 
            aria-labelledby={`v-pills-${workflow_process_history.id}-tab`}>
              <h4>ผู้ดำเนินงาน</h4>
              <hr className="mb-3" />

              <ExecutorRow  user_name={_.get(executor, "attributes.user_name")}
                            position_name={_.get(executor, "attributes.position_name")}
                            received_at={created_at}
                            sent_at={updated_at}
                            action_name={action_name} />

              {cc_users.map((cc_user) => {
                return(
                  <ExecutorRow  key={cc_user.id}
                                user_name={_.get(cc_user, "attributes.positions_user.attributes.user_name")}
                                position_name={_.get(cc_user, "attributes.positions_user.attributes.position_name")}
                                received_at={created_at}
                                action_name={"รับทราบ"} />
                )
              })}

      </div>
    )
  }

  renderCurrentTab(workflow_process){
    const isShowing = this.state.showingTabId === workflow_process.id;

    let current_state_name = _.get(workflow_process, "attributes.current_workflow_state.attributes.state_name");
    let assignees = _.get(workflow_process, "attributes.positions_users");
    const cc_users = _.get(workflow_process, "attributes.cc_positions_users") || [];

    const updated_at = _.get(workflow_process, "attributes.updated_at");
  
    if(current_state_name === "เอกสารส่งออก"){
      current_state_name = "เอกสารรอบันทึกรับ"
    }

    return(
      <div  key={workflow_process.id}
            className={`tab-pane fade ${isShowing && "show active"}`}
            id={`v-pills-${workflow_process.id}`}
            role="tabpanel" 
            aria-labelledby={`v-pills-${workflow_process.id}-tab`}>
              <h4>ผู้ดำเนินงาน</h4>
              <hr className="mb-3" />

              {assignees && (
                _.map(assignees, (assignee, index) => {
                  return(
                    <ExecutorRow  key={'assignee_' + index}
                                  user_name={_.get(assignee, "attributes.user_name")}
                                  position_name={_.get(assignee, "attributes.position_name")}
                                  received_at={updated_at}
                                  state_name={current_state_name} />
                  )
                })
              )}

              {cc_users.map((cc_user) => {
                return(
                  <ExecutorRow  key={cc_user.id}
                                user_name={_.get(cc_user, "attributes.positions_user.attributes.user_name")}
                                position_name={_.get(cc_user, "attributes.positions_user.attributes.position_name")}
                                received_at={updated_at} />
                )
              })}

      </div>
    )
  }

  renderTrackingRow(){
    const isShowing = this.state.showingTabId === "tracking";

    return(
      <a  key="tracking-row" 
          className={`nav-link text-black ${isShowing && "active"}`}
          data-toggle="pill" 
          href="#"
          role="tab" 
          aria-controls="v-pills-tracking"
          aria-selected="true"
          onClick={() => this.showTrackingTab()}>
            <i className="fa fa-envelope-o"></i>{' '}
            <span>ติดตามสถานะเอกสาร</span>
      </a>
    )
  }
  
  renderTrackingTab(workflow_process_id, campus_tracking_data){
    const self = this;
    const isShowing = this.state.showingTabId === "tracking";
    let error = false;

    return(
      <div  key="tracking"
            className={`tab-pane fade ${isShowing && "show active"}`}
            id="v-pills-tracking"
            role="tabpanel" 
            aria-labelledby="v-pills-tracking-tab">
            {Object.keys(campus_tracking_data).map(function(key, index) {
              if(campus_tracking_data[key]["status"] === "error") { error = true }

              return self.renderTrackingData(key, campus_tracking_data[key])
            })}
            
            {error === true && (
              <button onClick={() => this.handleResendClicked(workflow_process_id)} disabled={this.state.clicked} className="btn btn-success mb-3">ส่งเอกสารอีกครั้ง</button>
            )}
      </div>
    )
  }

  showTrackingTab(){
    this.setState({showingTabId: "tracking"});
  }

  renderTrackingData(campus_code, tracking_data){

    const tracking_histories = tracking_data.workflow_process_histories;

    return(
      <div key={`tracking-${campus_code}`} className="mb-3">
        <b>{tracking_data.campus_name}</b>
        
        {_.map(tracking_histories, this.renderTrackingHistoryRow)}

        <div>
          สถานะล่าสุด: 
          <span className={`pl-1 ${tracking_data.status == "error" ? "text-danger" : "text-success"}`}>{tracking_data.current_state}</span>
        </div>
        <div>อัพเดทเมื่อ: {tracking_data.timestamp}</div>
      </div>
    )
  }

  renderTrackingHistoryRow(tracking_history){
    console.log(tracking_history);

    const state_name = _.get(tracking_history, "attributes.state_name");
    const action_name = _.get(tracking_history, "attributes.action_name");
    const timestamp = _.get(tracking_history, "attributes.timestamp");

    return(
      <div>
        <i className="fa fa-check-square-o"></i>{' '}
        <span>
          {state_name}{" - "}
          <b>{action_name}</b>
          {" "}({timestamp})
        </span>
      </div>
    )
  }

  render(){
    const { workflow_process, workflow_process_histories, loading } = this.state;
    const campus_tracking_data = _.get(workflow_process, "attributes.campus_tracking_data", {});

    return(
      <div className="row">
        {loading === false && (
          <div className="col-4">
            <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              {_.map(workflow_process_histories, this.renderHistoryRow)}

              {this.renderCurrentRow(workflow_process)}

              { !_.isEmpty(campus_tracking_data) && this.renderTrackingRow(workflow_process) }
            </div>
          </div>
        )}

        {loading === false && (
          <div className="col-8">
            <div className="tab-content" id="v-pills-tabContent">
              {_.map(workflow_process_histories, this.renderHistoryTab)}

              {this.renderCurrentTab(workflow_process)}

              { !_.isEmpty(campus_tracking_data) && this.renderTrackingTab(workflow_process.id, campus_tracking_data) }
            </div>
          </div>
        )}

      </div>
    )
  }
}

export default withRouter(WorkflowProcessHistory);



// WEBPACK FOOTER //
// ./src/components/WorkflowProcessHistory.js